import React from 'react';
import { Input } from 'reactstrap';
import Select from 'react-select';

/*
 * Function to convert because the event of select return a object of fields "value" and "label", however validation's functions how
 * handleChange and handleValidation just accept object with a element target in format of input web return yours events.
 */
export const convertEventSelectToTarget = (name, value) => {
  return {
    target: {
      name,
      value,
    },
  };
};

export const SelectInput = ({
  multiple = false,
  className,
  invalid,
  ...rest
}) => {
  const styleInput = {
    control: () => ({
      display: 'flex',
      marginLeft: -10,
      color: 'red',
    }),
    singleValue: (styles, { isDisabled }) => ({
      ...styles,
      color: '#333',
    }),
  };

  return (
    <Input
      type="text"
      styles={styleInput}
      style={{
        color: 'red',
      }}
      multiple={multiple}
      isMulti={multiple}
      tag={Select}
      invalid={invalid}
      className={className + ' p-0 ps-3' + (invalid ? ' pe-4' : '')}
      components={{
        IndicatorSeparator: () => null,
      }}
      placeholder=" "
      {...rest}
    />
  );
};
